import { initDataLayer, isBrowser } from '../util';
import { clearFilterSelection } from './pushFilterSelection';
export function pushFilterResetClick(noSearchResults) {
    initDataLayer();
    if (!isBrowser)
        return;
    if (noSearchResults) {
        window.dataLayer.push({
            event: 'filterResetButtonClickNoResults',
            noSearchResults: true,
        });
    }
    else {
        window.dataLayer.push({
            event: 'filterResetButtonClick',
            noSearchResults: false,
        });
    }
    clearFilterSelection();
}
